import { Component, ElementRef, EventEmitter, OnInit, OnDestroy, Output, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { UserService } from 'src/app/_service/user.service';
import { AuthService } from 'src/app/_service/auth.service'; // Added
import { TranslateService } from '@ngx-translate/core';

import * as routing from '../../../_model/routing';
import { UserData, postUserData } from 'src/app/_model/user_data';
import { MatPaginator} from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Table } from 'primeng/table';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators'; // Added

interface Column {
  field: string;
  header: string;
}
@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.css'],
})
export class UserListComponent implements OnInit, OnDestroy { // Added OnDestroy
  @Output() dataChange = new EventEmitter();
  @ViewChild('table', {read: ElementRef}) table!: ElementRef;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  dataSource!: MatTableDataSource<UserData>;
  userList!: UserData[];
  columnName: string[];
  selectedRowIndex: number = -1;
  dataload: boolean = true;
  cols!: Column[];

  private authSubscription!: Subscription; // Added to track auth state timing

  constructor(
    private router: Router,
    private userService: UserService,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    private translate: TranslateService,
    public auth: AuthService // Injected AuthService
  ) {
    this.iconRegistry.addSvgIcon(
      'mail',
      sanitizer.bypassSecurityTrustResourceUrl('/assets/mail.svg')
    );
    this.iconRegistry.addSvgIcon(
      'call',
      sanitizer.bypassSecurityTrustResourceUrl('/assets/call.svg')
    );
    this.dataSource = new MatTableDataSource();
    this.columnName = ['name','tele','address','company','position', 'lastupdated', '*'];
  }
  
  userData!: postUserData;
  userId = '';
  selected: any;
  loading: boolean = true;

  ngOnInit(): void {
    this.cols = [
      { field: 'name', header: 'User Name' },
      { field: 'tele', header: 'Information Summary' },
      { field: 'address', header: 'Address' },
      { field: 'company', header: 'Company' },
      { field: 'position', header: 'Role' },
      { field: 'updatedAt', header: 'Last Updated' }
    ];

    // TIMING GUARD: Only contact the server after authentication state is loaded
    this.authSubscription = this.auth.authReady$
    .pipe(take(1)) 
    .subscribe({
      next: (isReady) => {
        if (isReady) {
          this.initUserList();
        } else {
          this.loading = false;
          this.userList = [];
        }
      },
      error: () => {
        this.loading = false;
        this.userList = [];
      }
    });
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
  }

  initUserList() {
    this.loading = true;

    this.userService.getUserList()
    .subscribe({
      next: (value) => {
        this.userList = value;
        this.userService.userList = value;
        this.loading = false;
      },
      error: (error) => {
        console.error('Error fetching user list:', error);
        this.loading = false;
      }
    })
  }

  onButtonClick(rowData: any) {
    // Permission Guard Check
    if (this.auth.isYakuin) {
      window.alert(this.translate.instant("noPermission"));
      return;
    }

    const topElement = document.querySelector('#top');
    if (topElement) {
      topElement.scrollIntoView({ behavior: 'instant', block: 'start' });
    }
    this.userId = rowData.id;
    this.userService.selectedUserID = this.userId;
    this.addToUserData(rowData);
  }

  jumpCreateUser() {
    this.router.navigate([routing.UserRegistration]);
  }

  addToUserData(data: UserData){
    this.userData = {
      name: data!.name,
      first_name: data!.first_name,
      last_name: data!.last_name,
      pincode: data!.pincode,
      position: data!.position,
      address: data!.address,
      telephone: data!.telephone,
      company_id: data!.company_id,
      role_id: data!.role_id,
      tenant_id: data!.tenant_id,
      fax: data!.fax,
      email: data!.email,
      thumbnailExtension: data!.thumbnailExtension,
      oid: data!.oid,
      vessel_id: data!.vessel_id,
    };
    this.userService.editUserFlag = true;
    this.userService.editUserData = this.userData;
    this.jumpUserPreview();
  }

  clearSearch(input: HTMLInputElement, dt: Table) {
    input.value = '';
    dt.filterGlobal('', 'contains');
  }

  jumpUserPreview() {
    this.router.navigate([routing.UserPreview + "/" + this.userService.selectedUserID]);
  }

  ngOnDestroy(): void {
    // Unsubscribe to protect against memory leak vectors
    if (this.authSubscription) {
      this.authSubscription.unsubscribe();
    }
  }
}